import { render, staticRenderFns } from "./ImportConfig.vue?vue&type=template&id=03c683e6&"
import script from "./ImportConfig.vue?vue&type=script&lang=js&"
export * from "./ImportConfig.vue?vue&type=script&lang=js&"
import style0 from "./ImportConfig.vue?vue&type=style&index=0&id=03c683e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports